import _get from 'lodash.get';
import ApiClient from '../../common/utils/apiClient';
import updateAuthToken from '../../common/utils/updateAuthToken';

export const actionTypes = {
    SHOW_TOP_UP_MODAL: 'SHOW_TOP_UP_MODAL',
    HIDE_TOP_UP_MODAL: 'HIDE_TOP_UP_MODAL',
    CARD_DETAILS_RECEIVED: 'CARD_DETAILS_RECEIVED',
    CARD_DETAILS_ERROR: 'CARD_DETAILS_ERROR',
    TOP_UP_FAIL: 'TOP_UP_FAIL',
};

export const showTopUpModal = () => ({
    type: actionTypes.SHOW_TOP_UP_MODAL,
});

export const hideTopUpModal = () => ({
    type: actionTypes.HIDE_TOP_UP_MODAL,
});

const topUpFail = errorInfo => ({
    type: actionTypes.TOP_UP_FAIL,
    errorInfo,
});

export const cardDetailsReceived = cardDetails => ({
    type: actionTypes.CARD_DETAILS_RECEIVED,
    cardDetails,
});

export const setCardDetailsError = () => ({
    type: actionTypes.CARD_DETAILS_ERROR,
});

export const getCardDetails = bookie => dispatch => (
    ApiClient.getCardDetails(bookie)
        .then((res) => {
            updateAuthToken(res.headers);
            if (
                res.status === 200 &&
                res.data &&
                res.data.data
            ) {
                const cardData = res.data.data.filter(card => card.type === 'card-info')[0] || {};

                if (cardData.attributes) {
                    const formattedCardData = {
                        cardId: cardData.id,
                        cardNumber: `**** ${cardData.attributes.card_number}`,
                        cleanCardNumber: cardData.attributes.card_number,
                        cardType: cardData.attributes.card_type,
                        maxDepositAmount: cardData.attributes.max_deposit_amount,
                        minDepositAmount: cardData.attributes.min_deposit_amount,
                    };

                    return dispatch(cardDetailsReceived(formattedCardData))
                }
            }
            return Promise.reject()
        })
        .catch(() => dispatch(setCardDetailsError()))
)

export const topUpAccountBalance = (
    bookie,
    cv2,
    amount,
    cardId,
) => (dispatch) => {
    const body = {
        cv2,
        amount: Math.round(parseFloat(amount) * 100) / 100,
        card_number: cardId,
    };

    return ApiClient.topUp(bookie, body)
        .then((res) => {
            updateAuthToken(res.headers);
            if (
                res.status === 200 &&
                res.data &&
                res.data.data &&
                res.data.data.attributes &&
                res.data.data.attributes.success
            ) {
                return dispatch(showTopUpModal())
            }
            return Promise.reject(res)
        })
        .catch((err) => {
            dispatch(topUpFail(_get(err, 'response.data.errors[0]', {})))
            return Promise.reject(err)
        });
}



// WEBPACK FOOTER //
// /src/js/common/topUp/topUp.actions.js